<template>
  <div style="width: 100%; height: 100%; margin-top: 20px; ">
    <p id="title" style="font-size: 18px; font-family: 黑体; font-weight: bold; color: white; margin-left: 10px;">各站点巡检情况</p>
    <div id="SubLeftThreeHeader" style="width: 107%; margin-left: 20px; margin-top: 10px;">
      <table>
        <thead>
        <tr>
          <th>站点名称</th>
          <th>是否已巡检</th>
          <th>巡检人</th>
          <th width="100">巡检时间</th>
          <!--<th>备注</th>-->
        </tr>
        </thead>
      </table>
    </div>
    <div id="SubLeftThreeContent" style="width: 107%; height: 160px; margin-left: 20px; overflow-y: scroll;    background-color: #26374b;">
      <table>
        <tbody>
        <tr v-for="item in tableData">
          <td ><div class="f-els3" :title="item.pointName">{{item.pointName}}</div></td>
<!--          <td>{{item.inspectFlag ? "是": "否"}}</td>-->
<!--          <td>{{item.inspectFlag ? "是": "否"}}</td>-->
          <th v-if="item.inspectFlag"><i class="el-icon-circle-check" style="color: lightgreen;"></i></th>
          <th v-else><i class="el-icon-circle-close" style="color: red;"></i></th>
          <td>{{item.inspectorName}}</td>
          <td width="100">{{item.inspectTime}}</td>
          <!--<th >{{item.five}}</th>-->
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SubLeftThree',
  props: ['areaId'],
  data(){
    return {
      // 获取各区巡检表
      AreaInspectSta:{
        "version": 1,
        "method": "synthScreen.AreaInspectSta",
        "params": {
          "areaId":"0",
        },
        "token": "#",
        "id": 0
      },
      midDate:"",
      tableData:[],
      formerTableData: [], // 上一次的数据
      interval:null // 轮询
    }
  },
  methods:{
    sortBy(a, b){
      console.log("a");
      console.log(a);
      console.log(Number(a.inspectFlag))
      console.log("b");
      console.log(b);
      console.log(Number(b.inspectFlag))
      // 否放前面
      return Number(a.inspectFlag) > Number(b.inspectFlag);
    },
    // 比较两个数组是否相等
    arrayCmp(arr1, arr2){
      console.log('arr1');
      console.log(arr1);
      console.log('arr2');
      console.log(arr2)
      return JSON.stringify(arr1) === JSON.stringify(arr2);
    },
    getAreaInspectSta(){
      // console.log('tableData');
      // console.log(this.tableData);
      let formerTableData = JSON.parse(JSON.stringify(this.tableData));
      // console.log('formerTableData');
      // console.log(formerTableData);
      // this.tableData = [];
      this.AreaInspectSta.token = this.$store.state.token;
      this.AreaInspectSta.params.areaId = this.areaId;
      this.$axios.post(this.$newMainUrl, this.AreaInspectSta).then(res=> {
        if(res.data.hasOwnProperty('result')){
          let a = [], b = [];
          res.data.result.inspectStatus.forEach(item =>{
            if(item.inspectFlag){
              a.push(item);
            }else{
              b.push(item);
            }
            let t = b.concat(a);
            // console.log('b.concat(a)');
            // console.log(b.concat(a));
            // console.log('former');
            // console.log(formerTableData);
            if(!this.arrayCmp(t, formerTableData)){
              // this.$message({
              //   type:'success',
              //   message: "变化了"
              // })

            }
          })
          this.tableData = b.concat(a);
        }else{
          this.$message({
            type:'error',
            message:'获取警报点静态信息失败，' + res.data.error.message
          })
        }
      })
    },
  },
  mounted(){
    this.getAreaInspectSta();
    this.interval = setInterval(()=>{
      this.getAreaInspectSta();
    }, 3000);
    // let n = 2;
    // while (n--){
    //   this.tableData.push({
    //     one: '云密城',
    //     two: '否',
    //     three: '张三',
    //     four: '2019-11-17',
    //     five: '无',
    //   })
    // }
  },
  destroyed(){
    clearInterval(this.interval);
    // this.$message({
    //   type: 'error',
    //   message: '结束'
    // })
  }
}
</script>

<style scoped lang="scss">
  #SubLeftThreeHeader, #SubLeftThreeContent{
    table{
      text-align: center;
      color: white;
      font-size: 16px;
      font-family: 黑体;
      transform: scale(1.0);
      width: 100%;
      border-collapse: collapse;
      /*colgroup{*/
        /*col:nth-child(1){*/
          /*width: 30px;*/
        /*}*/
        /*col:nth-child(2){*/
          /*width: 20px;*/
        /*}*/
      /*}*/
      tr{
        height: 30px;
        background-color: #26374b;
        th:nth-child(1), td:nth-child(1){
          width: 6em;
        }
        th:nth-child(2), td:nth-child(2){
          width: 6em;
        }
        th:nth-child(3), td:nth-child(3){
          width: 5em;
        }
        th:nth-child(4), td:nth-child(4){
          width: 10em;
        }

      }
    };
  }
  #SubLeftThreeHeader tr:first-child{
    background-color: #213380;
  }
</style>
<style>
  #SubLeftThreeContent::-webkit-scrollbar{
    display: none;
  }
  #SubLeftThreeContent{
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
  .f-els3{width: 6rem; overflow: hidden;text-overflow:ellipsis;white-space: nowrap;text-align: left; margin-left: 10px;}

</style>
